import React from 'react'
import '../../../ExtemdedReport/GlobalExtendedReport.scss'

type LegendItemProps = {
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    text: React.ReactNode;
};

const HeaderIcons: React.FC<LegendItemProps> = ({ Icon, text }) => {
    return (
        <div className="legend-item">
            <div className="legend-item__circle" aria-hidden>
                <Icon className="legend-item__icon" />
            </div>
            <span className="legend-item__text">{text}</span>
        </div>
    )
}

export default HeaderIcons